module.exports = __webpack_public_path__ + "img/iphone-rfidcard-POLAND-pl.49aa2444.webp";